import { render } from "./VabeneAddFeature.vue?vue&type=template&id=a20db7a6&scoped=true&ts=true"
import script from "./VabeneAddFeature.vue?vue&type=script&lang=ts"
export * from "./VabeneAddFeature.vue?vue&type=script&lang=ts"

import "./VabeneAddFeature.vue?vue&type=style&index=0&id=a20db7a6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a20db7a6"]])

export default __exports__